import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.entryAccountTitle.query,
    method: 'post',
    data: requestBody
  })
}

// 获取详情
export function detail(requestBody) {
  return request({
    url: URL.finance.entryAccountTitle.detail,
    method: 'post',
    data: requestBody
  })
}

// 新增/修改保存
export function save(requestBody) {
  return request({
    url: URL.finance.entryAccountTitle.save,
    method: 'post',
    data: requestBody
  })
}

// 删除
export function remove(requestBody) {
  return request({
    url: URL.finance.entryAccountTitle.remove,
    method: 'post',
    data: requestBody
  })
}

export function queryAccountTitle(requestBody) {
  return request({
    url: URL.finance.entryAccountTitle.queryAccountTitle,
    method: 'post',
    data: requestBody
  })
}

// 验证费用组,同一【凭证分组类型+数据类型】费用组不能重复
export function checkChargeGroup(requestBody) {
  return request({
    url: URL.finance.entryAccountTitle.checkChargeGroup,
    method: 'post',
    data: requestBody
  })
}
